var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fixedLabel ? _c('label', {
    staticClass: "settings-field-label",
    attrs: {
      "for": "search-stock-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.label || _vm.$translate('select_stock')))]) : _vm._e(), _c('SearchObject', {
    ref: "search",
    staticClass: "mt-0",
    attrs: {
      "input-id": _vm.fixedLabel ? "search-stock-".concat(_vm._uid) : undefined,
      "hide-label": _vm.fixedLabel,
      "placeholder": _vm.fixedLabel ? _vm.label : undefined,
      "load-on-mount": _vm.loadOnMount,
      "additional-params": Object.assign({
        ordering: 'name'
      }, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "create-label": _vm.createLabel || _vm.$translate('create_a_warehouse'),
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_stock'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "select-mode": _vm.selectWithoutSearch,
      "error-messages": _vm.errorMessages,
      "dense": _vm.dense,
      "clearable": _vm.clearable,
      "flat": _vm.flat,
      "outlined": _vm.outlined,
      "icon": _vm.icon,
      "menu-props": _vm.stockListMenuProps
    },
    on: {
      "create": _vm.createWarehouse,
      "input": _vm.onSearchInput,
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('StockOptionLabel', {
          attrs: {
            "variant": "menu",
            "name": item.name || '',
            "owner-name": _vm.stockItemOwnerCaption(item)
          }
        })];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _vm.selectWithoutSearch ? [item ? _c('StockOptionLabel', {
          attrs: {
            "variant": "field",
            "name": item.name || '',
            "owner-name": _vm.stockItemOwnerCaption(item)
          }
        }) : _vm._e()] : undefined;
      }
    }], null, true)
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }